export const GlobalConstants = Object.freeze({
  //BASE_API_URL: "http://192.168.1.201",
  BASE_API_URL: "https://data.kinghickoryb2b.com",
  BASE_API_URL_PORT: "8081", // External
  //BASE_API_URL_PORT: "80", // Inside network
  //BASE_API_URL_PORT: "8082", // Stage
});
